














































































































































































































































































import { useFilters } from '@/app/composable';
import { ChevronRightIcon, ExclamationIcon, XIcon } from '@vue-hero-icons/outline';
import { PropType, computed, defineComponent, ref } from '@vue/composition-api';
import { StatsPerField } from '../../types';
import FieldPath from '../FieldPath.vue';
import TransformationDetails from './TransformationDetails.vue';
import { useMappingTransformations } from '../../composable';

export default defineComponent({
    name: 'ConceptOverview',
    components: { ExclamationIcon, TransformationDetails, FieldPath, ChevronRightIcon, XIcon },
    props: {
        concept: {
            type: Object,
            required: true,
        },
        isFinalized: {
            type: Boolean,
            default: false,
        },
        successfulTransformations: {
            type: Object as PropType<StatsPerField>,
            required: false,
            default: null,
        },
        failedTransformations: {
            type: Object,
            required: false,
            default: null,
        },
        failedTransformationReasons: {
            type: String,
            required: false,
            default: null,
        },
        message: {
            type: Object,
            required: false,
        },
        validationErrors: {
            type: Object as PropType<
                Record<number, { message: string | null; description?: string | null; type?: string; title?: string }>
            >,
            required: true,
        },
        noTransformations: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const expanded = ref<boolean>(false);

        const { formatLargeNumber } = useFilters();
        const { getTransformations, getTransformationText } = useMappingTransformations();

        const transformations = computed(() => {
            return getTransformations(props.concept);
        });

        const failedTransformationReason = computed(() => {
            if (props.message?.stats && props.message?.failedTransformations && props.concept.source.id) {
                let fieldId: any = null;
                Object.entries(props.message.stats).forEach((entry: any) => {
                    const [key, value]: any = entry;
                    if (props.concept.source.id === value.source_id) fieldId = key;
                });
                if (fieldId) return props.message.failedTransformations[fieldId];
            }
            return null;
        });

        const sameSourceTargetType = computed(() => {
            let targetType = props.concept.target.type;
            if (['double', 'integer', 'float'].includes(targetType)) targetType = 'number';
            return targetType === props.concept.source.type;
        });

        const conceptClicked = () => {
            expanded.value = !expanded.value;
        };

        const trimPath = () => {
            props.concept.target.path.splice(-1, 1);
            props.concept.target.parentIds.splice(-1, 1);
        };

        return {
            expanded,
            trimPath,
            conceptClicked,
            transformations,
            getTransformationText,
            failedTransformationReason,
            formatLargeNumber,
            sameSourceTargetType,
        };
    },
});
